import {
  Compass,
  Code2,
  Megaphone,
  CircleDollarSign,
  Handshake,
  Layers,
  Settings2,
  Scale,
  LifeBuoy,
} from "lucide-react";

export const HATS = [
  {
    key: "ceo",
    label: "CEO & Vision",
    lead: "CEO",
    icon: Compass,
    reassurance: "Deciding alone is heavy. Having people to think out loud with changes it.",
  },
  {
    key: "tech",
    label: "Tech",
    lead: "Tech lead",
    icon: Code2,
    reassurance: "You don't have to understand everything, just enough to ask the right questions.",
  },
  {
    key: "marketing",
    label: "Marketing",
    lead: "Marketing lead",
    icon: Megaphone,
    reassurance: "Most solo founders waste time on the wrong channel. Direction beats effort here.",
  },
  {
    key: "money",
    label: "Money",
    lead: "finance lead",
    icon: CircleDollarSign,
    reassurance: "Knowing your numbers is a skill, not a talent. It can be learned fast.",
  },
  {
    key: "sales",
    label: "Sales",
    lead: "Sales lead",
    icon: Handshake,
    reassurance: "The first deals are the hardest. Everyone remembers theirs.",
  },
  {
    key: "product",
    label: "Product",
    lead: "Product lead",
    icon: Layers,
    reassurance: "Building less, and sooner, is usually the answer.",
  },
  {
    key: "operations",
    label: "Operations",
    lead: "Operations lead",
    icon: Settings2,
    reassurance: "Simple systems beat busy days.",
  },
  {
    key: "legal",
    label: "Legal & Admin",
    lead: "Legal & admin",
    icon: Scale,
    reassurance: "The boring stuff matters most when it's missing.",
  },
  {
    key: "support",
    label: "Customer Support",
    lead: "Support lead",
    icon: LifeBuoy,
    reassurance: "Every customer message is free research.",
  },
];

export const HAT_BY_KEY = Object.fromEntries(HATS.map((h) => [h.key, h]));

export const WEIGHT_WORDS = {
  1: "Light",
  2: "Manageable",
  3: "Heavy",
  4: "Very heavy",
  5: "Crushing",
};
